// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/registry_identifiers.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { RegistryEntityKind, RegistryMatchCandidate } from "./registry_resolve_pb";
/**
 * @generated from message mono.datagateway.v1.SuggestRegistryIdentifiersRequest
 */ export class SuggestRegistryIdentifiersRequest extends Message {
    static fromBinary(bytes, options) {
        return new SuggestRegistryIdentifiersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SuggestRegistryIdentifiersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SuggestRegistryIdentifiersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SuggestRegistryIdentifiersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryEntityKind kind = 1;
   */ _define_property(this, "kind", RegistryEntityKind.UNSPECIFIED), /**
   * @generated from field: string registry_id = 2;
   */ _define_property(this, "registryId", ""), /**
   * @generated from field: bool recheck = 3;
   */ _define_property(this, "recheck", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SuggestRegistryIdentifiersRequest, "runtime", proto3);
_define_property(SuggestRegistryIdentifiersRequest, "typeName", "mono.datagateway.v1.SuggestRegistryIdentifiersRequest");
_define_property(SuggestRegistryIdentifiersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(RegistryEntityKind)
        },
        {
            no: 2,
            name: "registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "recheck",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRegistryIdentifierStatusRequest
 */ export class GetRegistryIdentifierStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRegistryIdentifierStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRegistryIdentifierStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRegistryIdentifierStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRegistryIdentifierStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryEntityKind kind = 1;
   */ _define_property(this, "kind", RegistryEntityKind.UNSPECIFIED), /**
   * @generated from field: string registry_id = 2;
   */ _define_property(this, "registryId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRegistryIdentifierStatusRequest, "runtime", proto3);
_define_property(GetRegistryIdentifierStatusRequest, "typeName", "mono.datagateway.v1.GetRegistryIdentifierStatusRequest");
_define_property(GetRegistryIdentifierStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(RegistryEntityKind)
        },
        {
            no: 2,
            name: "registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistryIdentifierStatus
 */ export class RegistryIdentifierStatus extends Message {
    static fromBinary(bytes, options) {
        return new RegistryIdentifierStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryIdentifierStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryIdentifierStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryIdentifierStatus, a, b);
    }
    constructor(data){
        super(), /**
   * HAS_IDENTIFIER | SUGGESTED | QUEUED | BUDGET_WAIT | NO_MATCH | NO_SOURCE | SOURCE_OFF | DUPLICATE
   * ("" = never checked)
   *
   * @generated from field: string status = 1;
   */ _define_property(this, "status", ""), /**
   * SUGGESTED (IDENTIFIER_SUGGESTION) or DUPLICATE (POSSIBLE_DUPLICATE)
   *
   * @generated from field: mono.datagateway.v1.RegistryMatchCandidate candidate = 2;
   */ _define_property(this, "candidate", void 0), /**
   * @generated from field: google.protobuf.Timestamp checked_at = 3;
   */ _define_property(this, "checkedAt", void 0), /**
   * BUDGET_WAIT: next 00:00 UTC
   *
   * @generated from field: google.protobuf.Timestamp next_try_at = 4;
   */ _define_property(this, "nextTryAt", void 0), /**
   * "“Northwind” in VA"
   *
   * @generated from field: string query_label = 5;
   */ _define_property(this, "queryLabel", ""), /**
   * last check ≥ 24 h ago and part B on
   *
   * @generated from field: bool can_recheck = 6;
   */ _define_property(this, "canRecheck", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryIdentifierStatus, "runtime", proto3);
_define_property(RegistryIdentifierStatus, "typeName", "mono.datagateway.v1.RegistryIdentifierStatus");
_define_property(RegistryIdentifierStatus, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "candidate",
            kind: "message",
            T: RegistryMatchCandidate
        },
        {
            no: 3,
            name: "checked_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "next_try_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "query_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "can_recheck",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SuggestRegistryIdentifiersResponse
 */ export class SuggestRegistryIdentifiersResponse extends Message {
    static fromBinary(bytes, options) {
        return new SuggestRegistryIdentifiersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SuggestRegistryIdentifiersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SuggestRegistryIdentifiersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SuggestRegistryIdentifiersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryIdentifierStatus status = 1;
   */ _define_property(this, "status", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SuggestRegistryIdentifiersResponse, "runtime", proto3);
_define_property(SuggestRegistryIdentifiersResponse, "typeName", "mono.datagateway.v1.SuggestRegistryIdentifiersResponse");
_define_property(SuggestRegistryIdentifiersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "status",
            kind: "message",
            T: RegistryIdentifierStatus
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRegistryIdentifierStatusResponse
 */ export class GetRegistryIdentifierStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRegistryIdentifierStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRegistryIdentifierStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRegistryIdentifierStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRegistryIdentifierStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryIdentifierStatus status = 1;
   */ _define_property(this, "status", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRegistryIdentifierStatusResponse, "runtime", proto3);
_define_property(GetRegistryIdentifierStatusResponse, "typeName", "mono.datagateway.v1.GetRegistryIdentifierStatusResponse");
_define_property(GetRegistryIdentifierStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "status",
            kind: "message",
            T: RegistryIdentifierStatus
        }
    ]));
